import { render, staticRenderFns } from "./Filetemplate.vue?vue&type=template&id=0838f692&scoped=true"
import script from "./Filetemplate.vue?vue&type=script&lang=js"
export * from "./Filetemplate.vue?vue&type=script&lang=js"
import style0 from "./Filetemplate.vue?vue&type=style&index=0&id=0838f692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838f692",
  null
  
)

export default component.exports